import React, { useState, useEffect } from 'react';
import { InputGroup, Form } from 'react-bootstrap';
import { useAuth } from '../../../../../Auth';
import { useAxios } from '../../../../../AxiosHandler';

function Select(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loadedOptions, setLoadedOptions] = useState([]);

    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    const renderOptions = (options) => {
        return (
            options.map((option,key) => 
                <option key={key} value={option.value}>{option.label}</option>
            )
        );
    }

    useEffect(() => {
        if (
            props.options != undefined &&
            props.options.typeLoad != undefined && 
            props.options.typeLoad != "Manual"
        ) {
            switch (props.options.typeLoad) {
                case "Manual": break;
                case "User":
                    axios.all([
                        axios.single({
                            method: "get",
                            url: "/api/users",
                            responseType: "json",
                            headers: {'x-access-token': auth.user["token"]}
                        })
                    ])
                    .then(axios.spread((...res) => {
                        setLoadedOptions(res[0].data.map(user => { return {label: user["name"], value: user["_id"]} }));
                    }));
                    break;
            }
        }
    }, []);

    return(
        <InputGroup className="mb-3">
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
            : null}
            <Form.Control
                as="select"
                onKeyDown={ props.onKeyDown }
                disabled={props.disabled}
                onChange={(evt) => { handleChange({label: evt.currentTarget.value, value: evt.currentTarget.value})}}
                value={props.value != undefined ? props.value.value : (props.defaultValue != undefined ? props.defaultValue.value : "")}
            >
                {props.options != undefined && props.options.choosetext != undefined ? 
                    <option disabled={props.options != undefined && props.options.disableChoosetext != undefined && props.options.disableChoosetext == true ? true : false} value="">{props.options.choosetext}</option>
                : ""}
                {props.options != undefined && props.options.choices != undefined ? 
                    renderOptions(props.options.choices)
                : ""}
                {loadedOptions != undefined ? 
                    renderOptions(loadedOptions)
                : ""}
            </Form.Control>
        </InputGroup>
    );
}

export default Select;